import { deserialize, serialize } from "serializr";
import { NotificationTypes } from "../../enums/notificationTypes";
import axiosInstance from "../../interceptor/axiosInstance";
import { ExamModel } from "../../models/ExamModels/exam.model";
import { PaginationModel } from "../../models/PaginationModel/pagination.model";
import { EXAMS_LIST, EXAM_SUBJECTS_LIST } from "../../routes/routeConstants/apiRoutes";
import Notification from "../../shared/components/Notification";

export class ExamService {
    static createNewExam (
        data: any,
        onSuccess: Function,
        onError: Function
    ) {

        return axiosInstance
        .post(EXAMS_LIST, data,{headers:{'Content-Type':'multipart/form-data'}})
        .then(response => {
            onSuccess(response)
        })
        .catch(error => {
            onError(error)
        })
    }
    static fetchExams(
        queryParams: any,
        onSuccess: Function,
        onError: Function
    ){
        return axiosInstance
        .get(EXAMS_LIST+queryParams)
        .then(response => {
            const exams = deserialize(ExamModel, response.data["exams"])
            const meta = deserialize(PaginationModel, response.data["meta"])
            onSuccess(exams,meta)   
        })
        .catch(error => {
            Notification({ message: "Failed", description: "Unable to fetch the exams list",type: NotificationTypes.ERROR });
            onError(error)
        })
    }

    static updateExam(
        data: any,
        onSuccess: Function,
        onError: Function
    ){
        const payload = {exam: serialize(ExamModel, data?.exam)}
        return axiosInstance
        .put(EXAMS_LIST + `/${data.id}`, payload)
        .then(response => { 
            onSuccess(response)
        })  
        .catch(error => {
            Notification({ message: "Failed", description: "Unable to update the exam",type: NotificationTypes.ERROR });
            onError(error)
        })
    }

    static deleteExam(
        data: any,
        onSuccess: Function,
        onError: Function
    ){
        return axiosInstance
        .delete(EXAMS_LIST + `/${data.id}`)
        .then(response => {
            onSuccess(response)
        })  
        .catch(error => {
            Notification({ message: "Failed", description: "Unable to delete the exam",type: NotificationTypes.ERROR });
            onError(error)
        })
    }


  
}